<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-input title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="Сквозной порядковый номер" v-bind="$form.input('number')" />
        <n-input title="Дата сварки, температура воздуха, °С" v-bind="$form.input('weldingDate')" />
        <n-input title="Диаметр и толщина стенки трубы, мм" v-bind="$form.input('wallDiameter')" />
        <n-input title="ГОСТ или ТУ, марка стали, завод-поставщик труб" v-bind="$form.input('gost')" />
        <n-input title="Температура подогрева (просушки стыка), °С" v-bind="$form.input('tempHeating')" />
        <n-input title="Наименование и № свариваемых элементов трубопровода" v-bind="$form.input('title')" />
        <n-input title="Заводские номера труб" v-bind="$form.input('pipeNumber')" />
        <n-input title="Привязка стыка (для неповоротной сварки): километр" v-bind="$form.input('weldingKilometer')" />
        <n-input title="Привязка стыка (для неповоротной сварки): пикет" v-bind="$form.input('weldingPiket')" />
        <n-input title="Способ сварки и положение при сварке" v-bind="$form.input('weldingWay')" />
        <n-input title="Марка сварочных материалов" v-bind="$form.input('weldingMaterialMark')" />
        <n-input title="Фамилия, инициалы бригадира (звеньевого) и номер схемы расположения сварщиков" v-bind="$form.input('foreman')" />
        <n-input title="Номер шифра бригады или сварщика" v-bind="$form.input('cipherNumber')" />
        <n-input title="Приемка стыка: по результатам контроля физическими методами или механическим испытаниям (заключение о годности стыка, номер, дата заключения)" v-bind="$form.input('physicMethods')" />
        <n-input title="Сведения о проведении ремонта или удалении стыка: отремонтирован, удален, дата" v-bind="$form.input('fix')" />
        <n-input title="Приемка стыка после ремонта: по результатам контроля физическими методами (заключение о годности, номер и дата заключения)" v-bind="$form.input('result')" />
        <n-input title="Примечание" v-bind="$form.input('remark')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
